




























import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/header.vue";
import LeftNav from "../components/left-nav.vue";
import ResourceShixun from "../components/resource-shixun.vue";
import ResourceBingli from "../components/resource-bingli.vue";
import ResourceTupian from "../components/resource-tupian.vue";
import ResourceKejian from "../components/resource-kejian.vue";
import ResourceShipin from "../components/resource-shipin.vue";
@Component({
  components: {
    Header,
    LeftNav,
    ResourceShixun,
    ResourceBingli,
    ResourceTupian,
    ResourceKejian,
    ResourceShipin,
  },
})
export default class Name extends Vue {
  private cTab: any = "";
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private changeTab(val: any) {
    this.cTab = val;
    this.$store.commit("updateResourceTab", val);
    localStorage.setItem("resourceFilter", "");
  }
  mounted() {
    if (!this.$store.state.resourceTab) {
      this.cTab = this.$store.state.resourceTab;
      this.$store.commit(
        "updateResourceTab",
        this.$store.state.systemInfo.SETTING.ziyuan[0]
      );
    }
    this.cTab = this.$store.state.resourceTab;
  }
}
